export const TEST_IDS = {
  avatarLink: 'avatar-link',
  commentAuthorAssociation: 'comment-author-association',
  commentHeaderLeftSideItems: 'comment-header-left-side-items',
  commentHeaderRightSideItems: 'comment-header-right-side-items',
  commentHeaderHamburger: 'comment-header-hamburger',
  commentHeaderHamburgerOpen: 'comment-header-hamburger-open',
  commentMenuRefComment: 'comment-menu-ref-comment',
  commentViewerOuterBox: (id: string | undefined) => {
    return id ? `comment-viewer-outer-box-${id}` : 'comment-viewer-outer-box'
  },
  commentComposer: 'comment-composer',
  markdownBody: 'markdown-body',
  markdownEditor: (postFix = '') => `markdown-editor-${postFix}`,
  readonlyMarkdownEditor: (postFix = '') => `readonly-markdown-editor-${postFix}`,
  commentSkeleton: 'comment-skeleton',
}
